import {eventsLogService} from '../services'

const state = {
    all: {
        loading: false,
        total: 0,
        rows: []
    },
}

const actions = {

    getAll ({ dispatch, commit }, params) {
        commit('getAllRequest')
        eventsLogService.getAll(params).then(
            response => {
                commit('getAllSuccess', response)
            }
        )
    },


}

const mutations = {
    getAllRequest (state, params) {
        state.all = { loading: true, total: 0, rows: [] }
    },
    getAllSuccess (state, data) {
        state.all = { loading: false, total: data.total, rows: data.rows }
    },
}

const getters = {
}

export const eventsLogModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
